import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import axios from "axios";
export default {
  props: {
    institution: {
      type: String,
      required: true
    }
  },
  emits: ["close", "created"],
  data() {
    return {
      saving: false,
      form: {
        name: "",
        grade: "",
        school: "",
        phone: "",
        parentPhones: [""],
        source: ""
      }
    };
  },
  methods: {
    validPhone(phone) {
      return !phone || /^1[3-9]\d{9}$/.test(phone);
    },
    addParentPhone() {
      this.form.parentPhones.push("");
    },
    removeParentPhone(index) {
      this.form.parentPhones.splice(index, 1);
    },
    async save() {
      const parentPhones = [...new Set(this.form.parentPhones.filter(Boolean))];
      if (!this.form.phone && parentPhones.length === 0) return alert("学生或家长手机号至少填一个");
      if (!this.form.name || !this.form.grade || !this.form.school || !this.form.source) return alert("请填写完整信息");
      if (!this.validPhone(this.form.phone) || parentPhones.some(phone => !this.validPhone(phone))) return alert("请输入正确的手机号");
      this.saving = true;
      try {
        const response = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/addStudent", {
          ...this.form,
          parentPhone: parentPhones[0] || "",
          parentPhones,
          institution: this.institution
        });
        if (response.data.code !== "0000") return alert("添加失败：" + response.data.msg);
        this.$emit("created");
      } catch (error) {
        alert("添加失败：" + error);
      } finally {
        this.saving = false;
      }
    }
  }
};